import { unescape as unescapeHtmlEntities } from 'lodash';

/**
 * htmlToPlainText
 *
 * Strip HTML tags from a text content:
 *
 * - a space will be added between tags;
 * - html entities will be unescaped;
 * - spaces will be trimmed;
 * - missing content (null or undefined) is also handled.
 *
 * @param {string} content (optional)
 * @returns {string} plain text
 */
export const htmlToPlainText = (content) =>
  unescapeHtmlEntities(
    (content || '')
      .replace(/<(.*?)>/g, ' ')
      .replace(/\s+/gi, ' ')
      .replace(/&nbsp;/g, ' ')
      .trim(),
  );
